// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"70efc6fb","436":"84aec15e","453":"f394a27d","501":"f14ba4be","606":"c5c10cd6","925":"ff1d9c71"}[chunkId] + ".chunk.js";
};